import API from '../../apiCreate'
import { getParams } from '../../getParams'
import type { AxiosRequestConfig } from 'axios'
import type {
  CrmIntegrationEndpointCreateBody,
  CrmIntegrationEndpointCallBody,
  CrmIntegrationEndpointType,
  CrmIntegrationEndpointUpdateBody,
  ResponseCrmIntegrationEndpoint,
  ResponseCrmIntegrationEndpointList,
} from './crm-integration-endpoint.types'
import type { ResponseWrapper } from '../../types/base.types'

type ApiRequestConfigWithGlobalAlertFlag = AxiosRequestConfig & {
  skipGlobalErrorAlert?: boolean
}

export const crmIntegrationEndpointApi = {
  /** GET /v1/crm-integration-endpoint?type= */
  getAll: (type?: CrmIntegrationEndpointType | string) =>
    API.get<ResponseCrmIntegrationEndpointList>(
      `crm-integration-endpoint${type ? getParams({ type }) : ''}`,
    ),

  /** POST /v1/crm-integration-endpoint/create */
  create: (
    data: CrmIntegrationEndpointCreateBody,
    conf?: ApiRequestConfigWithGlobalAlertFlag,
  ) =>
    API.post<ResponseCrmIntegrationEndpoint>(
      'crm-integration-endpoint/create',
      data,
      conf,
    ),

  /** PUT /v1/crm-integration-endpoint/update?id= */
  update: (
    id: number,
    data: CrmIntegrationEndpointUpdateBody,
    conf?: ApiRequestConfigWithGlobalAlertFlag,
  ) =>
    API.put<ResponseCrmIntegrationEndpoint>(
      `crm-integration-endpoint/update${getParams({ id })}`,
      data,
      conf,
    ),

  /** DELETE /v1/crm-integration-endpoint/delete?id= */
  remove: (id: number, conf?: ApiRequestConfigWithGlobalAlertFlag) =>
    API.delete<ResponseCrmIntegrationEndpoint>(
      `crm-integration-endpoint/delete${getParams({ id })}`,
      conf,
    ),

  /** POST /v1/crm-integration-endpoint/refresh-mango?id= */
  refreshMango: (id: number) =>
    API.post<ResponseCrmIntegrationEndpoint>(
      `crm-integration-endpoint/refresh-mango${getParams({ id })}`,
    ),

  /** POST /v1/crm-integration-endpoint/refresh-novofon?id= */
  refreshNovofon: (id: number) =>
    API.post<ResponseCrmIntegrationEndpoint>(
      `crm-integration-endpoint/refresh-novofon${getParams({ id })}`,
    ),

  /** POST /v1/crm-integration-endpoint/call?id= */
  call: (
    id: number,
    data: CrmIntegrationEndpointCallBody,
    conf?: ApiRequestConfigWithGlobalAlertFlag,
  ) =>
    API.post(
      `crm-integration-endpoint/call${getParams({ id })}`,
      data,
      conf,
    ),

  /** POST /v1/crm-integration-endpoint/recording?id= */
  getRecording: (id: number, data: { lead_id: number; recording_id: string }) =>
    API.post<ResponseWrapper<{ url: string }>>(
      `crm-integration-endpoint/recording${getParams({ id })}`,
      data,
    ),
}
